export default __webpack_public_path__ + "static/media/WinterArts2022-Chase-Gray-Pixel-Moments-Credit-SabrinaMisoCreative-1.91930ab6.jpg";